import styled from 'styled-components';

export const BannerCard = styled.div`
    flex-basis: 60%;
    margin-left: 30px;
`;
export const Banner = styled.div`
  background-color: #172647;
  height: 275px;
  color: white;
  text-align: center;
  font-size: 36px;
`;

export const CoursesContainer = styled.div`
  background-color: #F7F9FF;
  padding: 90px 0px;
`;

export const AboutContainer = styled.div`
  position: relative;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 12px;
  width: 80%;
  margin: 0 10%;
  top: -50px;
`;
